var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('HeaderBreadcrumbs', {
    attrs: {
      "items": [{
        label: 'Brand',
        to: '/ax/items/brand-ax'
      }, {
        label: 'Add New'
      }],
      "title": "New Brand"
    }
  }), _c('div', {
    staticClass: "flex-col w-full bg-white shadow-sm rounded-lg px-4 py-3"
  }, [_c('div', {
    staticClass: "w-1/2"
  }, [_c('h4', {
    staticClass: "font-bold text-xl leading-7 mb-4 block"
  }, [_vm._v("Create New Brand")]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Item Name ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.name,
      expression: "name"
    }],
    staticClass: "w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2",
    attrs: {
      "id": "basePrice",
      "type": "text",
      "placeholder": "Enter Item Name"
    },
    domProps: {
      "value": _vm.name
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mb-3 mr-2"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Brand ")]), _c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Select Item Name",
      "open-direction": "bottom",
      "required": "required",
      "options": _vm.brandSearchOptions,
      "searchable": true,
      "loading": _vm.isBrandSearch,
      "close-on-select": true,
      "options-limit": 10,
      "multiple": false,
      "allow-empty": false
    },
    on: {
      "search-change": _vm.brandFind
    },
    model: {
      value: _vm.brand,
      callback: function ($$v) {
        _vm.brand = $$v;
      },
      expression: "brand"
    }
  })], 1), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Base Price ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.basePrice,
      expression: "basePrice"
    }],
    staticClass: "w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2",
    attrs: {
      "id": "basePrice",
      "type": "number",
      "min": "0",
      "placeholder": "Enter Base Price"
    },
    domProps: {
      "value": _vm.basePrice
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.basePrice = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mb-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Subscription ID AX ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.subsIdAx,
      expression: "subsIdAx"
    }],
    staticClass: "w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2",
    attrs: {
      "id": "subsIdAx",
      "type": "number",
      "min": "0",
      "placeholder": "Enter Single ID AX"
    },
    domProps: {
      "value": _vm.subsIdAx
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.subsIdAx = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mt-3 mr-1.5"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Vendor ")]), _c('multiselect', {
    attrs: {
      "label": "name",
      "track-by": "name",
      "placeholder": "Select Vendor",
      "open-direction": "bottom",
      "options": _vm.items_vendor,
      "searchable": true,
      "loading": _vm.isLoadingSearch,
      "close-on-select": true
    },
    on: {
      "search-change": _vm.findVendorName,
      "input": _vm.getVendorAx
    },
    model: {
      value: _vm.vendor,
      callback: function ($$v) {
        _vm.vendor = $$v;
      },
      expression: "vendor"
    }
  }, [_c('span', {
    attrs: {
      "slot": "noResult"
    },
    slot: "noResult"
  }, [_vm._v(" Oops! No elements found. Consider changing the search query. ")])])], 1), _c('div', {
    staticClass: "mt-3"
  }, [_c('label', {
    staticClass: "block text-sm font-medium text-gray-700 mb-2",
    attrs: {
      "for": "name"
    }
  }, [_vm._v(" Vendor ID AX ")]), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.vendor_id_ax,
      expression: "vendor_id_ax"
    }],
    staticClass: "w-full rounded-md px-4 border py-2.5 text-sm focus:outline-none focus:ring-2",
    attrs: {
      "id": "basePrice",
      "type": "text",
      "placeholder": "Vendor ID AX"
    },
    domProps: {
      "value": _vm.vendor_id_ax
    },
    on: {
      "input": function ($event) {
        if ($event.target.composing) { return; }
        _vm.vendor_id_ax = $event.target.value;
      }
    }
  })]), _c('div', {
    staticClass: "mt-4 mb-3 mr-0 flex justify-start"
  }, [_c('button', {
    staticClass: "bg-blue-600 text-white px-4 py-2 rounded-lg mr-3",
    on: {
      "click": function ($event) {
        return _vm.addBrandAx();
      }
    }
  }, [_vm._v("Save")]), _c('button', {
    staticClass: "bg-whit text-gray-500 border px-4 py-2 rounded-lg",
    attrs: {
      "type": "reset"
    }
  }, [_c('router-link', {
    staticClass: "text-gray-500 no-underline hover:no-underline hover:text-gray-500",
    attrs: {
      "size": "sm",
      "to": {
        name: _vm.brandItemAx.name
      }
    }
  }, [_vm._v(" Cancel ")])], 1)])])])], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }